import React, { useState, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import LoadingGIF from '../../../assets/loadingIn.gif';
import '../../../assets/styles/caterer-invoicing.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/**
 * Dedicated PDF Viewer for Caterer Invoice module.
 * Dynamically scales the PDF canvas to fit the right-side preview panel
 * without horizontal overflow or excess margins.
 */
export default function CatererPdfViewer({ fileHolder, pageNumber = 1, setNumPages, setPageNumber }) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        if (rect.width > 0) {
          setContainerWidth(Math.floor(rect.width));
        }
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    const timer = setTimeout(updateWidth, 150);
    return () => {
      window.removeEventListener('resize', updateWidth);
      clearTimeout(timer);
    };
  }, []);

  function onDocumentLoadSuccess(pdf) {
    if (setNumPages) {
      setNumPages(pdf._pdfInfo?.numPages || 1);
    }
    if (setPageNumber) {
      setPageNumber(1);
    }
  }

  // Calculate target page width to fit container seamlessly (subtract padding)
  const targetWidth = containerWidth ? Math.max(containerWidth - 24, 280) : 580;

  return (
    <div
      ref={containerRef}
      className='caterer-pdf-viewer sm-scrollbar'
    >
      <Document
        file={fileHolder}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div className='flexRow justifyContentCenter alignItemsCenter caterer-pdf-viewer__loading'>
            <span className='flexRow alignItemsCenter gap10'>
              <img src={LoadingGIF} className='icon-size' style={{ width: '25px', height: '25px' }} alt="Loading" />
              Loading PDF Invoice...
            </span>
          </div>
        }
      >
        <Page
          key={`page_${pageNumber}`}
          pageNumber={pageNumber || 1}
          width={targetWidth}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </div>
  );
}
